import { Component } from '@angular/core';
import { CalculationsContentResources } from '../../content/resources/calculations.content-resources';
import { LoadingEnum } from '../../enums/loading.enum';
import { FetchPriorityEnum } from '../../enums/fetch-priority.enum';
import { RouteManager } from '../../managers/route.manager';
import { RouteEnum } from '../../enums/route.enum';
import { LocaleManager } from '../../managers/locale.manager';
import { ContentManager } from '../../content/managers/content.manager';
import { Meta, Title } from '@angular/platform-browser';
import { BaseComponent } from '../../components/base.component';

@Component({
  selector: 'app-calculations',
  templateUrl: './calculations.component.html',
  styleUrl: './calculations.component.scss',
  standalone: false,
})
export class CalculationsComponent extends BaseComponent {

  protected readonly CalculationsContentResources = CalculationsContentResources;
  protected readonly LoadingEnum = LoadingEnum;
  protected readonly FetchPriorityEnum = FetchPriorityEnum;
  protected readonly RouteEnum = RouteEnum;

  constructor(
    localeManager: LocaleManager,
    routeManager: RouteManager,
    contentManager: ContentManager,
    titleService: Title,
    meta: Meta,
  ) {
    super(
      localeManager,
      routeManager,
      contentManager,
      titleService,
      meta,
      CalculationsContentResources,
    );
  }
}
